import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const FormSection = memo(
  ({
    title,
    children,
    textStyle,
    disabled = false,
    containerStyle,
    ...rest
  }) => {
    const { styles } = useStyle();
    return (
      <View {...rest}>
        {title && <Text style={[styles.titleText, textStyle]}>{title}</Text>}
        <View style={[styles.contentContainer, containerStyle]}>
          {children}
        </View>
        {disabled && <View style={styles.ovelay} />}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  titleText: {
    fontSize: 14,
    color: colors.black,
    textAlign: 'center',
  },
  contentContainer: {
    paddingVertical: 16,
  },
  ovelay: {
    backgroundColor: colors.white3,
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
}));
